module.exports = __webpack_public_path__ + "static/media/beach2380.c4959ab1.jpg";